// @@REPORT_PERIODS_v115_1@@ Period picker for report generation: no typed dates.
// Options are the current period plus the 36 months / 12 quarters before it, newest first. Values are the FIRST DAY of the
// period as YYYY-MM-DD (what POST …/reports expects); built from parts, never via toISOString(), so no UTC off-by-one.
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const MON3 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const pad = (n) => String(n).padStart(2, '0');

// existing: [{ period_type, period_start }] already generated for this store.
// -> { options: [{ value, label, done, inProgress }], defaultValue }   (defaultValue = most recent COMPLETED period)
export function periodOptions(type, existing, now) {
  const t = type === 'quarter' ? 'quarter' : 'month';
  const today = now || new Date();
  const have = new Set((existing || []).map((r) => r.period_type + '|' + String(r.period_start || '').slice(0, 10)));
  const step = t === 'quarter' ? 3 : 1;
  const count = t === 'quarter' ? 12 : 36;
  let y = today.getFullYear();
  let m = t === 'quarter' ? Math.floor(today.getMonth() / 3) * 3 : today.getMonth(); // 0-based first month of the period
  const options = [];
  for (let i = 0; i < count; i++) {
    const value = y + '-' + pad(m + 1) + '-01';
    const label = t === 'quarter'
      ? 'Q' + (m / 3 + 1) + ' ' + y + ' (' + MON3[m] + '–' + MON3[m + 2] + ')'
      : MONTHS[m] + ' ' + y;
    options.push({ value, label, done: have.has(t + '|' + value), inProgress: i === 0 });
    m -= step;
    if (m < 0) { m += 12; y -= 1; }
  }
  return { options, defaultValue: options[1].value };
}

// The selected value if it belongs to the current list, else the default. -> 'YYYY-MM-DD'
export function resolvePeriod(type, selected, existing, now) {
  const { options, defaultValue } = periodOptions(type, existing, now);
  return options.some((o) => o.value === selected) ? selected : defaultValue;
}
